import React from "react";

const FlavorNameTable = () => {
  return (
    <ol>
      <li>7up</li>
      <li>a w cream soda</li>
      <li>a w root bear</li>
      <li>Acai Berry</li>
      <li>Apple Pie la Cold Stone</li>
      <li>Barbados Cherry</li>
      <li>Berry Blue</li>
      <li>Birthday Cake</li>
      <li>Birthday Cake Remix</li>
      <li>Blue Raspberry</li>
      <li>Blueberry</li>
      <li>Bubble Gum</li>
      <li>Buttered Popcorn</li>
      <li>Cantaloupe</li>
      <li>Cappuccino</li>
      <li>Caramel Corn</li>
      <li>Cherry Passion Fruit Smoothie</li>
      <li>Chocolate Devotion</li>
      <li>Chocolate Pudding</li>
      <li>Cinnamon</li>
      <li>Cinnamon Apple Filled</li>
      <li>Coconut</li>
      <li>Cotton Candy</li>
      <li>Cranberry</li>
      <li>Cranberry Raspberry</li>
      <li>Crushed Pineapple</li>
      <li>DrPepper</li>
      <li>French Vanilla</li>
      <li>Gin Tonic</li>
      <li>Glazed Blueberry Cake</li>
      <li>Grape Crush</li>
      <li>Green Apple</li>
      <li>Island Punch</li>
      <li>Jewel Berry Blue</li>
      <li>Jewel Blueberry</li>
      <li>Jewel BubbleGum</li>
      <li>Jewel Champagne</li>
      <li>Jewel CreamSoda</li>
      <li>Jewel GingerAle</li>
      <li>Jewel GrapeSoda</li>
      <li>Jewel Orange</li>
      <li>Jewel Sour Apple</li>
      <li>Jewel Sour Lemon</li>
      <li>Jewel Very Cherry</li>
      <li>Juicy Pear</li>
      <li>Kiwi</li>
      <li>Kiwi Strawberry</li>
      <li>Lemon</li>
      <li>Lemon Drop</li>
      <li>Lemon Lime</li>
      <li>Lemon meringue Pie</li>
      <li>Licorice</li>
      <li>Mandarin Orange Mango Smoothie</li>
      <li>Mango</li>
      <li>Mango Madness</li>
      <li>Mango Milke Tea</li>
      <li>Margarita</li>
      <li>Matcha Milk Tea</li>
      <li>Mimosa</li>
      <li>Mint Chocolate Chip</li>
      <li>Mixed Berry Smoothie</li>
      <li>Mojito</li>
      <li>Moscow Mule</li>
      <li>Orange Crush</li>
      <li>Orange Sherbet</li>
      <li>Original Glazed</li>
      <li>Our Strawberry Blonde</li>
      <li>Peach</li>
      <li>Pineapple Pear Smoothie</li>
      <li>Pink Lemonade</li>
      <li>Pina Colada</li>
      <li>Plum</li>
      <li>Pomegranate</li>
      <li>Pomegranate Cosmo</li>
      <li>Raspberry</li>
      <li>Red Apple</li>
      <li>Rose</li>
      <li>Smores</li>
      <li>Sizzling Cinnamon</li>
      <li>Sour Apple</li>
      <li>Sour Cherry</li>
      <li>Sour Grape</li>
      <li>Sour Lemon</li>
      <li>Sour Orange</li>
      <li>Strawberry Banana Smoothie</li>
      <li>Strawberry Cheesecake</li>
      <li>Strawberry Daiquiri</li>
      <li>Strawberry Iced</li>
      <li>Strawberry Jam</li>
      <li>Strawberry Milk Tea</li>
      <li>Sunkist Lemon</li>
      <li>Sunkist Lime</li>
      <li>Sunkist Orange</li>
      <li>Sunkist Pink Grapefruit</li>
      <li>Sunkist Tangerine</li>
      <li>Taro Milk Tea</li>
      <li>Thai Milk Tea</li>
      <li>Toasted Marshmallow</li>
      <li>Top Banana</li>
      <li>Tutti Fruitti</li>
      <li>Very Cherry</li>
      <li>Watermelon</li>
      <li>Wild Blackberry</li>
    </ol>
  );
};

export default FlavorNameTable;
